export default function makeProdUrl(url: string): string {
  return url.replace(/content.georgiancollege.ca/gim, `www.georgiancollege.ca`)
}
